export default __webpack_public_path__ + "static/media/rx2.5cb2e0aa.jpeg";